const billingCycles = ["ANNUAL", "MONTHLY"] as const;
type BillingCycle = (typeof billingCycles)[number];

export { billingCycles };
export type { BillingCycle };
